
import React from "react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type Worker = {
  id: string;
  name: string;
};

interface WorkerSelectorProps {
  workers: Worker[];
  selectedWorker: string;
  onWorkerChange: (workerId: string) => void;
}

export const WorkerSelector: React.FC<WorkerSelectorProps> = ({
  workers,
  selectedWorker,
  onWorkerChange,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <Label className="block text-[#333333] font-bold mb-2">
        Sélectionnez un ouvrier
      </Label>
      <Select value={selectedWorker} onValueChange={onWorkerChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Choisir un ouvrier" />
        </SelectTrigger>
        <SelectContent>
          {workers.map((worker) => (
            <SelectItem key={worker.id} value={worker.id}>
              {worker.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
